export default "__VITE_ASSET__628ff7e1__"